import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';

export const Rehab: React.FC = () => {
    const scrollToContact = () => {
        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section id="facilities" className="py-20 md:py-32 bg-white">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">
                    {/* Content Side */}
                    <motion.div 
                         initial={{ opacity: 0, x: -30 }}
                         whileInView={{ opacity: 1, x: 0 }}
                         viewport={{ once: true }}
                         className="flex flex-col justify-center order-2 lg:order-1"
                    >
                        <span className="text-[#11BC97] font-bold tracking-widest uppercase text-xs md:text-sm mb-4 block flex items-center gap-2">
                            <span className="w-8 h-[1px] bg-[#11BC97]"></span>
                            Recovery
                        </span>
                        <h2 className="text-3xl md:text-5xl font-bold mb-6 md:mb-8 text-black leading-tight">World Class Rehabilitation</h2>
                        
                        <div className="bg-[#F8FDFB] rounded-[2rem] p-6 md:p-8 border border-[#11BC97]/10 mb-8">
                             <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-4">
                                Trained by <strong>Dr Dror Paley</strong> and <strong>Dr Anil Bhave</strong> at the prestigious Rubin Institute for Advanced Orthopaedics 
                                in Baltimore, Maryland.
                            </p>
                            <div className="flex items-center gap-4 mt-6">
                                <div className="h-12 w-12 rounded-full bg-[#11BC97]/20 flex items-center justify-center text-[#11BC97] font-bold">A</div>
                                <div>
                                    <p className="font-bold text-black">Arman & Mari Apelyan</p>
                                    <p className="text-sm text-gray-500">Rehabilitation Specialists</p>
                                </div>
                            </div>
                        </div>

                        <p className="text-gray-500 leading-relaxed text-base md:text-lg font-light mb-8">
                            The pair have built their internationally-renowned practice around the very latest innovations in the field of 
                            physiotherapeutic medicine, offering cutting-edge singular and combination treatment options to optimise 
                            your recovery and wellbeing.
                        </p>
                        
                        <div>
                             <Button onClick={scrollToContact}>Book Rehab Assessment</Button>
                        </div>
                    </motion.div>

                    {/* Image Side - Bento Style */}
                    <div className="grid grid-cols-2 gap-4 h-[400px] md:h-[600px] order-1 lg:order-2">
                         <motion.div 
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className="col-span-2 row-span-2 rounded-[2rem] md:rounded-[2.5rem] overflow-hidden relative"
                        >
                            <img src="/rehab.jpg" className="w-full h-full object-cover" alt="Gym" />
                            <div className="absolute inset-0 bg-black/10" />
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};